import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	data: [],
	loaded: false,
	fetching: false,
	currentCompany: null,
	currentCompanyId: null,
	initialCompany: null,
}

const companies = createSlice({
	name: 'COMPANIES',
	initialState,
	reducers: {
		fetched(state, { payload }) {
			if (payload.length) {
				state.data = payload
				state.loaded = true
				state.fetching = false
			}
		},

		fetching(state, { payload }) {
			state.fetching = payload
		},

		loaded(state, { payload }) {
			state.loaded = payload
		},

		setCurrentCompany(state, { payload: company }) {
			if (company) {
				state.currentCompany = company
				state.currentCompanyId = company.id
			}
		},

		setCurrentCompanyId(state, { payload: companyId }) {
			if (companyId) {
				state.currentCompanyId = companyId
			}
		},

		setInitialCompany(state, { payload: company }) {
			if (company) {
				state.initialCompany = company
				state.currentCompanyId = company.id
			}
		},
	},
})

export const Creators = companies.actions
export const {
	setCurrentCompany,
	setInitialCompany,
	setCurrentCompanyId,
	fetched,
	fetching,
	loaded,
} = companies.actions

export default companies.reducer
